(function($) {


  function setPaddings() {

    container_width = $('.container-fluid').width();
    full_width = $(window).width();
    padding = (full_width - container_width) / 2;

    $('#heroBanner .owl-prev').css('left',padding);
    $('#heroBanner .owl-next').css('right',padding);

  }

  $(document).ready(function(){

    //-------------------------------------------
    //Initialize Hero Carousel
    //-------------------------------------------
    $('#heroBanner').owlCarousel({
       loop:true,
       nav:true,
       dots:false,
       autoplay:true,
       autoplaySpeed: 1300,
       items:1,
       margin:0,
       navText: ['<span class="icon-arrow-circle"></span>','<span class="icon-arrow-circle"></span>'],
       navContainer: '#heroBanner'
    });

    $('#wwdSlider').on('initialized.owl.carousel',function(){
      $.fn.matchHeight._update();
      $('#wwdSlider .slider-item .top').matchHeight();
      $('#wwdSlider .slider-item .bottom').matchHeight();
    }).owlCarousel({
       loop:true,
       nav:true,
       dots:false,
       autoplay:true,
       autoplaySpeed: 700,
       margin:20,
       navText: ['<span class="icon-arrow-circle"></span>','<span class="icon-arrow-circle"></span>'],
       navContainer: '#wwdSlider',
       responsive: {
          0: {
            items:1
          },
          768: {
            items:2
          },
          992: {
            items:3
          },
          1200: {
            items:4
          }
       }
    });

    $('#testSlider').owlCarousel({
       loop:true,
       nav:false,
       dots:false,
       autoplay:true,
       autoplaySpeed: 700,
       items:1,
       margin:0
    });

    $('input[type="file"]').nicefileinput({
     label: "BROWSE" 
    });
    
    $('select').selectbox();

    $('#mainHeader #topWrapper #searchWrapper .search-button').click(function(){
      $('#mainHeader #topWrapper #searchWrapper #searchForm').toggleClass('opened');
      $('#mainHeader #topWrapper #searchWrapper #searchForm input').focus();
    });

    $('#searchWrapper2 .search-button').click(function(){
      $('#searchWrapper2 #searchForm').toggleClass('opened');
      $('#searchWrapper2 #searchForm input').focus();
    });


    //-------------------------------------------
    //Handle Burger stack
    //-------------------------------------------
    $('.burger-btn').click(function() {
      $(this).toggleClass('opened');
      $('#respWrapper').slideToggle();
    });

    $('.close-btn').click(function() {
      $('#respWrapper').slideToggle();
      $('.burger-btn').toggleClass('opened');
    });

    setPaddings();

    $('#respWrapper li.menu-item-has-children').each(function(){
      $(this).append('<span class="icon-arrow"></span>');
    });


   });

   $(window).load(function(){

    $('.initial-hidden').css('opacity',1); 
    setPaddings();

    $('#respWrapper li.menu-item-has-children .icon-arrow').click(function(){
      $(this).parent('li').children('.sub-menu').slideToggle();
      $(this).toggleClass('active');
    });

    $('.quick-links .box:eq(1)').click(function(e){
      $('#RequestModal').modal('show');
      e.preventDefault();
    });

  });

   $(window).resize(function(){
      setPaddings();
      $.fn.matchHeight._update();
      $('#wwdSlider .slider-item .top').matchHeight();
      $('#wwdSlider .slider-item .bottom').matchHeight();
   });

})(jQuery); // Fully reference jQuery after this point.
